import { useQuery } from '@tanstack/react-query';
import { getLegacyConnectorClient } from './ClientServicesCloud';
import { SessionDto } from '@bludata/fc-legacyconnector';

export const getSessions = async (): Promise<SessionDto[]> => {
  try {
    const result = await getLegacyConnectorClient().getCurrentSessions();

    console.log('getSessions result:', result);

    return result;
  } catch (error) {
    console.error('Error fetching sessions:', error);
    return [];
  }
};

export const useSessions = () => {
  return useQuery({
    queryFn: async () => await getSessions(),
    queryKey: ['sessions'],
    retry: 2,
    retryDelay: 180000,
    gcTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
